<mat-toolbar color="primary" class="d-flex justify-content-between">
  <div class="d-flex align-items-center">
    <fa-icon [icon]="faFileExcel" class="mr-3 text-white"></fa-icon>
    <div class="d-flex flex-column">
      <h2 class="mb-0 h6 text-white">{{ 'modals.import-survey-team.title' | translate }} <span class="small text-white-50" *ngIf="fileName && step > 1">- {{ fileName }}</span></h2>
    </div>
  </div>
  <button mat-icon-button (click)="close()" [disabled]="loading" class="text-white">
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>

<mat-progress-bar *ngIf="loading" mode="indeterminate" color="accent"></mat-progress-bar>

<div class="modal-body p-0 position-relative d-flex flex-column" style="min-height: 450px; max-height: 75vh;">

  <!-- Stepper Navigation -->
  <div class="bg-white border-bottom pt-3 sticky-top" style="z-index: 10;">
    <div class="container">
      <div class="d-flex align-items-center justify-content-center stepper-container pt-3 pb-0">
        <!-- Step 1 -->
        <div class="d-flex align-items-center step-item" [class.active]="step === 1" [class.completed]="step > 1">
          <div class="step-icon">
            <mat-icon *ngIf="step > 1">check</mat-icon>
            <span *ngIf="step <= 1">1</span>
          </div>
          <span class="step-label ml-2 small font-weight-bold">{{ 'modals.import-survey-team.step1-title' | translate }}</span>
        </div>

        <div class="step-connector mx-3"></div>

        <!-- Step 2 -->
        <div class="d-flex align-items-center step-item" [class.active]="step === 2" [class.completed]="step > 2" [class.disabled]="step < 2">
          <div class="step-icon">
            <mat-icon *ngIf="step > 2">check</mat-icon>
            <span *ngIf="step <= 2">2</span>
          </div>
          <span class="step-label ml-2 small font-weight-bold">{{ 'modals.import-survey-team.step2-title' | translate }}</span>
        </div>

        <div class="step-connector mx-3"></div>

        <!-- Step 3 -->
        <div class="d-flex align-items-center step-item" [class.active]="step === 3" [class.disabled]="step < 3">
          <div class="step-icon">
            <span>3</span>
          </div>
          <span class="step-label ml-2 small font-weight-bold">{{ 'modals.import-survey-team.step3-title' | translate }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="step-content pt-0 px-3 pb-3 flex-grow-1 overflow-auto">
    <!-- Step 1: Upload -->
    <div *ngIf="step === 1" class="text-center pt-3 pb-0">
      <div class="upload-box p-4 border rounded-lg bg-light mb-3"
           (click)="fileInput.click()" style="cursor: pointer; border-style: dashed !important; border-width: 2px !important;">
        <mat-icon style="font-size: 64px; width: 64px; height: 64px; color: #7b55c8;" class="mb-3 opacity-75">cloud_upload</mat-icon>
        <h3 class="font-weight-bold">{{ 'modals.import-survey-team.upload-title' | translate }}</h3>
        <p class="text-muted">{{ 'modals.import-survey-team.upload-subtitle' | translate }}</p>
        <div class="d-flex justify-content-center mt-3">
          <button mat-stroked-button color="primary" class="mr-2 rounded-pill">
            <mat-icon class="mr-1">search</mat-icon>
            {{ 'modals.import-survey-team.browse-files' | translate }}
          </button>
          <button mat-button color="primary" (click)="downloadTemplate($event)" class="rounded-pill">
            <fa-icon [icon]="faDownload" class="mr-1"></fa-icon>
            {{ 'modals.import-survey-team.download-template' | translate }}
          </button>
        </div>
        <input type="file" #fileInput (change)="onFileChange($event)" hidden accept=".xlsx, .xls, .csv">
      </div>

      <div class="alert alert-warning border-0 d-inline-flex align-items-center py-2 px-3 rounded shadow-sm">
        <fa-icon [icon]="faExclamationTriangle" class="mr-2 text-warning"></fa-icon>
        <span class="small font-weight-bold">{{ 'modals.import-survey-team.upload-warning' | translate }}</span>
      </div>
    </div>

    <!-- Step 2: Mapping -->
    <div *ngIf="step === 2">
      <div class="mt-3">
        <h5 class="font-weight-bold text-butterfly m-0 d-flex align-items-center mb-3">
          <mat-icon class="mr-2" color="primary">contact_page</mat-icon>
          {{ 'modals.import-survey-team.personal-data-title' | translate }}
        </h5>

        <div class="row">
          <div class="col-md-6 mb-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ 'generic.name' | translate }} *</mat-label>
              <mat-select [(ngModel)]="mapping.name">
                <mat-option value="">{{ 'modals.import-survey-team.select-column' | translate }}</mat-option>
                <mat-option *ngFor="let col of excelColumns; let i = index" [value]="i">
                  {{ col }} <span class="small text-muted" *ngIf="samples[0] && samples[0][i]">({{ samples[0][i] }})</span>
                </mat-option>
              </mat-select>
              <mat-icon matPrefix color="primary" class="mr-2">person</mat-icon>
            </mat-form-field>
          </div>

          <div class="col-md-6 mb-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ 'generic.surname' | translate }}</mat-label>
              <mat-select [(ngModel)]="mapping.last_name">
                <mat-option value="">{{ 'modals.import-survey-team.select-column' | translate }}</mat-option>
                <mat-option *ngFor="let col of excelColumns; let i = index" [value]="i">
                  {{ col }} <span class="small text-muted" *ngIf="samples[0] && samples[0][i]">({{ samples[0][i] }})</span>
                </mat-option>
              </mat-select>
              <mat-icon matPrefix color="primary" class="mr-2">person_outline</mat-icon>
            </mat-form-field>
          </div>

          <div class="col-md-6 mb-3">
            <mat-form-field appearance="outline" class="w-100" [class.mat-form-field-invalid]="!mapping.email">
              <mat-label>{{ 'generic.email' | translate }} *</mat-label>
              <mat-select [(ngModel)]="mapping.email">
                <mat-option value="">{{ 'modals.import-survey-team.select-column' | translate }}</mat-option>
                <mat-option *ngFor="let col of excelColumns; let i = index" [value]="i">
                  {{ col }} <span class="small text-muted" *ngIf="samples[0] && samples[0][i]">({{ samples[0][i] }})</span>
                </mat-option>
              </mat-select>
              <mat-icon matPrefix color="primary" class="mr-2">email</mat-icon>
            </mat-form-field>
          </div>

          <div class="col-md-6 mb-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ 'generic.phone' | translate }}</mat-label>
              <mat-select [(ngModel)]="mapping.phone_number">
                <mat-option value="">{{ 'modals.import-survey-team.select-column' | translate }}</mat-option>
                <mat-option *ngFor="let col of excelColumns; let i = index" [value]="i">
                  {{ col }} <span class="small text-muted" *ngIf="samples[0] && samples[0][i]">({{ samples[0][i] }})</span>
                </mat-option>
              </mat-select>
              <mat-icon matPrefix color="primary" class="mr-2">phone</mat-icon>
            </mat-form-field>
          </div>

<!--          <div class="col-md-6 mb-3">-->
<!--            <mat-form-field appearance="outline" class="w-100">-->
<!--              <mat-label>{{ 'modals.import-survey-team.role-from-excel' | translate }}</mat-label>-->
<!--              <mat-select [(ngModel)]="mapping.role">-->
<!--                <mat-option value="">{{ 'modals.import-survey-team.no-map' | translate }}</mat-option>-->
<!--                <mat-option *ngFor="let col of excelColumns; let i = index" [value]="i">-->
<!--                  {{ col }} <span class="small text-muted" *ngIf="samples[0] && samples[0][i]">({{ samples[0][i] }})</span>-->
<!--                </mat-option>-->
<!--              </mat-select>-->
<!--              <mat-icon matPrefix color="primary" class="mr-2">groups</mat-icon>-->
<!--            </mat-form-field>-->
<!--          </div>-->
        </div>
      </div>

      <!-- Custom Fields Section -->
      <div *ngIf="data.teamMemberCustomFields.length > 0" class="">
        <h5 class="font-weight-bold text-butterfly m-0 d-flex align-items-center mb-3">
          <mat-icon class="mr-2" color="primary">settings_suggest</mat-icon>
          {{ 'modals.import-survey-team.custom-fields-title' | translate }}
        </h5>
        <div class="row">
          <div *ngFor="let cf of data.teamMemberCustomFields" class="col-md-6 mb-2">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ cf.name }}</mat-label>
              <mat-select [(ngModel)]="customFieldsMapping[cf.id]">
                <mat-option value="">{{ 'modals.import-survey-team.no-import' | translate }}</mat-option>
                <mat-option *ngFor="let col of excelColumns; let i = index" [value]="i">
                  {{ col }} <span class="small text-muted" *ngIf="samples[0] && samples[0][i]">({{ samples[0][i] }})</span>
                </mat-option>
              </mat-select>
              <mat-icon matPrefix color="primary" class="mr-2">list</mat-icon>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Advanced Settings -->
      <div class="mb-4">
        <h5 class="font-weight-bold text-butterfly m-0 d-flex align-items-center mb-3">
          <mat-icon class="mr-2" color="primary">settings</mat-icon>
          {{ 'modals.import-survey-team.advanced-settings-title' | translate }}
        </h5>

        <div class="row">
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ 'modals.import-survey-team.start-row' | translate }}</mat-label>
              <input matInput type="number" [(ngModel)]="startRow" min="1">
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ 'modals.import-survey-team.end-row' | translate }}</mat-label>
              <input matInput type="number" [(ngModel)]="endRow" [max]="totalRows + 1">
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <!-- Step 3: Summary -->
    <div *ngIf="step === 3" class="d-flex flex-column h-100">
      <div class="px-4 py-3" style="flex: 1; overflow-y: auto;">
        <!-- Success Alert (> 0) -->
        <div *ngIf="importedMembersCount > 0" class="alert alert-success border-0 shadow-sm d-flex align-items-center p-4 mb-4 rounded-4" role="alert">
          <mat-icon class="mr-4 text-success" style="font-size: 48px; width: 48px; height: 48px">check_circle</mat-icon>
          <div>
            <h4 class="alert-heading mb-1 fw-bold text-success">{{ 'modals.import-survey-team.ready-to-import' | translate }}</h4>
            <p class="mb-0 fs-5 text-dark" [innerHTML]="'modals.import-survey-team.members-ready-desc' | translate: { count: importedMembersCount }"></p>
          </div>
        </div>

        <!-- Warning Alert (0) -->
        <div *ngIf="importedMembersCount === 0" class="alert alert-warning border-0 shadow-sm d-flex align-items-center p-4 mb-4 rounded-4" role="alert">
          <mat-icon class="mr-4 text-warning" style="font-size: 48px; width: 48px; height: 48px">report_problem</mat-icon>
          <div>
            <h4 class="alert-heading mb-1 fw-bold text-warning">{{ 'modals.import-survey-team.no-members-found' | translate }}</h4>
            <p class="mb-0 fs-5 text-dark">{{ 'modals.import-survey-team.no-members-desc' | translate }}</p>
          </div>
        </div>

        @if (importedMembersCount > 0) {
          <div class="card border-0 shadow-sm rounded-4 overflow-hidden border">
            <div class="table-responsive">
              <table class="table table-hover mb-0">
                <thead class="bg-light sticky-top" style="z-index: 5;">
                <tr>
                  <th class="border-0 px-4 py-3 text-muted text-uppercase fw-bold letter-spacing-1" style="font-size: 0.75rem;">{{ 'modals.import-survey-team.full-name' | translate }}</th>
                  <th class="border-0 px-4 py-3 text-muted text-uppercase fw-bold letter-spacing-1" style="font-size: 0.75rem;">{{ 'generic.email' | translate }}</th>
                  <th class="border-0 px-4 py-3 text-muted text-uppercase fw-bold letter-spacing-1 text-right" style="font-size: 0.75rem;">{{ 'generic.actions' | translate }}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let row of previewSamples; let i = index">
                  <td class="px-4 py-3 align-middle">
                    <div class="d-flex align-items-center">
                      <span class="fw-bold text-dark">{{ row[mapping.name] }} {{ row[mapping.last_name] }}</span>
                    </div>
                  </td>
                  <td class="px-4 py-3 align-middle">
                    <span class="text-secondary">{{ row[mapping.email] }}</span>
                  </td>
                  <td class="px-4 py-3 align-middle text-right">
                    <div class="d-flex align-items-center justify-content-end">
                      <button mat-icon-button color="warn" class="btn-delete" (click)="removeRow(row)" [matTooltip]="'generic.delete' | translate">
                        <mat-icon>delete_outline</mat-icon>
                      </button>
                    </div>
                  </td>
                </tr>

                <tr *ngIf="importedMembersCount === 0">
                  <td colspan="3" class="text-center py-5">
                    <mat-icon class="text-muted mb-2" style="font-size: 48px; width: 48px; height: 48px; opacity: 0.3;">person_search</mat-icon>
                    <p class="text-muted mb-0">{{ 'modals.import-survey-team.no-members-to-import' | translate }}</p>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="modal-footer p-3 border-top bg-white d-flex align-items-center justify-content-between">
    <button mat-button (click)="step === 1 ? close() : goToStep(step - 1)" [disabled]="loading" class="rounded-pill px-4">
      <mat-icon class="mr-1">chevron_left</mat-icon>
      {{ step === 1 ? ('generic.cancel' | translate) : ('modals.import-survey-team.back' | translate) }}
    </button>

    <div>
      <button *ngIf="step === 2" mat-flat-button color="primary" class="rounded-pill px-5 py-2 shadow-sm" (click)="goToStep(3)" [disabled]="loading ||
            (mapping.email === null || mapping.email === undefined) ||
            (mapping.name === null || mapping.name === undefined)">
        {{ 'modals.import-survey-team.continue' | translate }}
        <mat-icon class="ml-1">chevron_right</mat-icon>
      </button>

      <button *ngIf="step === 3" mat-flat-button color="primary" class="rounded-pill px-5 py-2 shadow-sm" (click)="confirmImport()" [disabled]="loading || importedMembersCount === 0">
        <mat-icon class="mr-3">cloud_upload</mat-icon>
        {{ 'modals.import-survey-team.confirm-import' | translate }} ({{ importedMembersCount }})
      </button>
    </div>
  </div>
</div>
